if (!customElements.get("cart-items")) {
  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      if (!event.detail.cartItemsHTML) return;

      this.innerHTML = event.detail.cartItemsHTML.innerHTML;

      document.dispatchEvent(new CustomEvent("cart:forced-resize"));
    }

    disconnectedCallback() {
      document.removeEventListener("cart:update-html", this.handleUpdateRef);
    }

    connectedCallback() {
      document.addEventListener("cart:update-html", this.handleUpdateRef);
    }
  }
  customElements.define("cart-items", CartItems);
}
